import axios from 'axios'
import { loadAbort } from 'utilities'

export const validateCompany = (validationCode: string) => {
  const controller = loadAbort()
  const url = `${process.env.REACT_APP_BASE_URL}/rfx/companies/validate_company/?validation_code=${validationCode}`
  return {
    call: axios.get(url, { signal: controller.signal }),
    controller,
  }
}
